import { createSelector } from 'reselect'
import StoreState from './state'
import AuthState from 'services/auth/state'

const authSelector = (state: StoreState) => state.auth
export const hydrationSelector = (state: StoreState) => state.hydration
export const tokensStateSelector = createSelector(authSelector, auth => auth.tokens as AuthState['tokens'])
